const getPixel = () => {
  // @ts-ignore
  const isFBQ = typeof window !== 'undefined' && window.fbq != null;
  // @ts-ignore
  return isFBQ ? window.fbq : isFBQ;
};

export const fbPixel = getPixel();
